<template>
  <v-card>
    <v-card-title class="font-weight-bold black--text">{{labTitle}}</v-card-title>
    <v-card-text class="text-subtitle-1 black--text">
      {{labPreview}}
      <router-link to="lab/about">Читать полностью...</router-link>
    </v-card-text>
  </v-card>
</template>

<script>
import {getLabText} from "@/helpers/labText";

export default {
  name: "LabPreview",
  data () {
    return {
      labTitle: '',
      labPreview: '',
    }
  },

  created() {
    const labText = getLabText()
    this.labTitle = labText.labTitle
    this.labPreview = labText.labPreview
  }
}
</script>

<style scoped>

</style>